import React, { Component } from 'react';
import {Route} from 'react-router-dom'

import logo from './logo.svg';

import './App.css';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import {createMuiTheme} from '@material-ui/core/styles'
import { withStyles } from '@material-ui/core/styles';

import * as Colors from '@material-ui/core/colors';
import {grey, amber, red} from '@material-ui/core/colors'




import AppBar from '@material-ui/core/AppBar';
import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom'

import Contact from './Component/Contact';
import About from './Component/About';
import Home from './Component/Home';
import Navigation from './Component/Navigation';
import LightTracker from './Component/LightTracker';
import StoneListing from './Component/StoneListing';
import RisFeed from './Component/RisFeed';
import FzoFeed from './Component/FzoFeed';
import PiStatus from './Component/PiStatus';

import Divider from '@material-ui/core/Divider';



const muiThemeAppBar = createMuiTheme({
  palette: ({
    textColor: Colors.darkBlack,
    primary1Color: Colors.green100,
    alternateTextColor: Colors.darkBlack,
    primary2Color: Colors.indigo700,
    accent1Color: Colors.redA200,
    pickerHeaderColor: Colors.darkBlack,
  }),
  appBar: {
    height: 60,
    
  },
});




class App extends Component {

  constructor(props) {
    super(props);
    this.state = {open: false};
  }

  handleDrawerToggle = () => this.setState({open: !this.state.open});
  handleDrawerClose = () => this.setState({open: false});

  render() {
    return (
      <div>
        <Navigation />
        <LightTracker />
        <br></br>
        <Divider />
        <RisFeed />
        <Divider />
        <FzoFeed/>
        <Divider />
        <PiStatus />       
        <Divider />
        <StoneListing />

      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js